import { cva, type VariantProps } from 'class-variance-authority';

export const accordionVariants = cva(
  [
    // Transitions
    // Outline
    'outline-none',
    // Focus state
    'focus:border-neutral-500 focus-visible:ring focus-visible:ring-neutral-100',
    // Disabled state
    'disabled:pointer-events-none disabled:opacity-50',
  ],
  {
    variants: {
      variant: {
        'no-background': 'border-b border-neutral-200',
        white: 'bg-white border rounded-sm border-neutral-200 ',
        neutral: 'bg-neutral-50 rounded-sm',
        primary: 'bg-primary-50 border border-primary-700 rounded-sm',
        secondary: 'bg-secondary-50 border border-secondary-700 rounded-sm',
      },
    },
    defaultVariants: {
      variant: 'no-background',
    },
  },
);

export type AccordionVariantProps = VariantProps<typeof accordionVariants>;
